import { config } from "@/config";
import * as Frigade from "@frigade/react";
import { useFlow } from "@frigade/react";
import { useEffect, useState } from "react";
import { OnboardingSteps } from "../OnboardingGuide";
import OnboardingFlow from "./OnboardingFlow";

const OnboardingReaderAnnouncementFlow = () => {
  const { flow } = useFlow(config.frigade.flows.gettingStarted);
  const currentStep = flow?.getCurrentStep();
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (currentStep?.id as OnboardingSteps === "generate_report") {
      const timer = setTimeout(() => {
        setShouldRender(true);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [currentStep]);

  if (currentStep?.id as OnboardingSteps === "generate_report" && shouldRender) {
    return (
      <OnboardingFlow>
        <Frigade.Announcement
          flowId={config.frigade.flows.readerAnnouncement}
          defaultOpen={true}
        />
      </OnboardingFlow>
    );
  }

  return null;
};

export default OnboardingReaderAnnouncementFlow;